import {OrderItem} from '../../../store/supportCaseStore';
import {useState} from 'react';
import styles from './item.module.css';
import clsx from 'clsx';

interface ItemProps {
    item: OrderItem;
    onSelect: (item: OrderItem) => void;
    onDeselect: (item: OrderItem) => void;
    requireQty?: boolean;
    onSelectQty?: (qty: number) => void;
    maxQty?: number;
    first?: boolean;
    last?: boolean;
}

export const Item = ({
    item,
    onSelect,
    onDeselect,
    requireQty,
    onSelectQty,
    maxQty,
    first,
    last,
}: ItemProps) => {
    if (requireQty && !maxQty)
        throw new Error('maxQty is required when requireQty is true');
    if (requireQty && onSelectQty === undefined)
        throw new Error('onSelectQty is required when requireQty is true');

    const [isChecked, setIsChecked] = useState(false);
    const [qty, setQty] = useState(maxQty ?? 1);
    maxQty = maxQty ?? 1;

    const options = [
        <option value="0" key="0">
            0
        </option>,
    ];
    for (let i = 1; i <= maxQty; i++) {
        options.push(
            <option value={i} key={i}>
                {i}
            </option>
        );
    }

    return (
        <label
            className={clsx(
                styles.wrapper,
                first && styles.wrapper_first,
                last && styles.wrapper_last
            )}
        >
            <div>
                {(!isChecked || (isChecked && !requireQty)) && (
                    <input
                        type={'checkbox'}
                        onChange={() => {
                            if (isChecked) onDeselect(item);
                            if (!isChecked) onSelect(item);

                            setIsChecked(!isChecked);
                        }}
                    />
                )}
                {isChecked && requireQty && (
                    <select
                        defaultValue={qty.toString()}
                        onChange={e => {
                            if (+e.target.value === qty) {
                                return;
                            }
                            if (e.target.value === '0') {
                                setIsChecked(false);
                                setQty(maxQty ?? 1);

                                return;
                            }
                            setQty(+(e.target as HTMLSelectElement).value);
                            if (onSelectQty)
                                onSelectQty(
                                    +(e.target as HTMLSelectElement).value
                                );
                        }}
                        style={{
                            lineHeight: '1.5rem',
                            padding: '0.5rem',
                            borderRadius: '0.25rem',
                            borderColor: 'rgba(0, 0, 0, 0.2)',
                            backgroundColor: 'white',
                        }}
                    >
                        {options}
                    </select>
                )}
            </div>
            <div className={styles.imageContainer}>
                <img
                    className={styles.image}
                    alt={item.description}
                    src={item.salable.imageUrl ?? undefined}
                />
            </div>
            <div>{item.description}</div>
        </label>
    );
};
